import { Link } from "react-router-dom";

// Cinematic button. Variant keys kept for API compat:
// pink/sunny → gold primary, ink → silver outline, paper → cream outline.
export const CTA = ({
  as = "link",
  to = "#",
  onClick,
  children,
  variant = "pink",
  className = "",
  type,
  disabled,
  ...rest
}) => {
  const variants = {
    pink: "btn-sweep border border-gold bg-gradient-to-b from-goldlight to-gold text-onyx shadow-[0_0_30px_rgba(201,162,39,0.3)] hover:-translate-y-0.5",
    sunny: "btn-sweep border border-gold bg-gradient-to-b from-goldlight to-gold text-onyx shadow-[0_0_30px_rgba(201,162,39,0.3)] hover:-translate-y-0.5",
    ink: "border border-silver/40 bg-transparent text-silver hover:border-gold hover:text-goldlight",
    paper: "border border-cream/40 bg-transparent text-cream hover:border-gold hover:text-goldlight",
  };
  const base =
    `group inline-flex items-center justify-center gap-2 px-7 py-3.5 font-head text-sm font-extrabold uppercase tracking-[0.2em] ` +
    `transition-all duration-200 disabled:opacity-60 disabled:hover:translate-y-0 ${variants[variant]} ${className}`;

  if (as === "button") {
    return (
      <button type={type || "button"} onClick={onClick} disabled={disabled} className={base} {...rest}>
        {children}
      </button>
    );
  }
  return (
    <Link to={to} onClick={onClick} className={base} {...rest}>
      {children}
    </Link>
  );
};
